import PrimaryMenu from './MenuPrimary'

export default PrimaryMenu
